"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DefaultMessages = {
  passwordRequired: 'La contraseña es obligatoria',
  passwordStrength: 'La contraseña no cumple los requisitos!',
  passwordMinLength: 'La contraseña no cumple la longitud mínima',
  passwordMaxLength: 'La contraseña excede la longitud máxima permitida',
  passwordRequireLetterAndNumber: 'La contraseña debe contener numeros y letras',
  passwordExactLength: 'La contraseña no cumple con la cantidad requerida de caracteres',
  cardNumberRequired: 'El número de tarjeta es obligatorio',
  invalidCardNumber: 'El número de tarjeta es inválido',
  holderNameRequired: 'El nombre del titular es obligatorio',
  expiresRequired: 'La fecha de vencimiento es obligatoria',
  invalidExpires: 'La fecha de vencimiento es inválida',
  securityCodeRequired: 'El código de seguridad es obligatorio',
  sketchRequired: 'El campo es obligatorio',
  apiInstanceError: 'The instance of API was not configured.',
  rollbarInstanceError: 'The instance of Rollbar was not configured.'
};